:host {
  --aspect-ratio: inherit;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  max-height: 100%;
  aspect-ratio: var(--aspect-ratio);
}
